/**
 * Actions for classrooms module
 */
import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getCourseClassrooms(payload) {
  return { type: actionTypes.GET_CLASSROOMS, payload };
}

export function getCourseClassroomsSuccess(payload) {
  const byId = keyBy(payload, (classroom) => classroom.classroom_urlUid);
  return { type: actionTypes.GET_CLASSROOMS_SUCCESS, payload: { byId } };
}
